//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BCard, BCardBody } from 'bootstrap-vue';
import { Icon } from '@iconify/vue2';

export default {
    name: "CourseCardSummary",
    components: { BCard, BCardBody, Icon },
    props: {
        description: Array,
        topics: Array,
    },
    data() {
        return {
            buttonURL: "/es/concretar-compra",
            paymentMethod: ["paypal"]
        }
    },
    methods: {
        onBtnClick() {
            this.$emit("btnClick");
            let payment = document.querySelectorAll('input[type="checkbox"]:checked');
            sessionStorage.setItem('coursePaymentMethod', payment[0].value);
        },
    },
    mounted() {
        this.paymentMethod = sessionStorage.coursePaymentMethod;
    },
};
